'use strict';

export const searchCatTagAutocompleteFieldElements = () => ({
    input: document.querySelector('input[name="what"]'),
    container: document.querySelector('div.what.autocomplete-container')
});